
























































































































































import User from '@/models/user';
import {API} from '@/services/api/api';
import {Utils} from '@/utils/Utils';
import validator from '@/utils/validator';
import moment from 'moment';
import {Vue, Component, Provide, Emit, Watch, Prop} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['shipList', 'currentTabActionPlan'])},
})
export default class ActionPlan extends Vue {
  @Prop({default: false}) canFetchDataFromAPI!: boolean;
  showSuccessToast: any;
  showErrorToast: any;
  currentTabActionPlan: any;
  isScreenLoading = true;
  loadingBtnStatus = false;
  typeOfIssue = '';
  issueValidationMsg = '';
  personInCharge: number = null;
  personInChargeValiMsg = '';
  action = '';
  actionValidationMsg = '';
  deadlineDate = '';
  deadlineValidationMsg = '';
  actionPlanData = {};
  rootCause = '';
  isReadOnly = false;
  commonValidationMsg = 'This field is required';
  userList: User[] = []; //api response

  inspectionId = this.$route.params.id;

  typeOfIssuess = [
    {
      id: 1,
      name: 'Structural',
    },
    {
      id: 2,
      name: 'Non Structural',
    },
    {
      id: 3,
      name: 'Others',
    },
  ];

  mounted() {
    this.getUserList();

    if (this.canFetchDataFromAPI) {
      this.getActionPlanData();
    }
  }

  async getActionPlanData() {
    try {
      this.isScreenLoading = true;
      let response = await API.fetchActionPlanDataByInspectionId(this.inspectionId);

      if (response.data) {
        const data = response.data;
        const actionPlanData = data.actionPlan;
        this.typeOfIssue = actionPlanData.typeOfIssue;
        this.personInCharge = actionPlanData.personInCharge;
        this.deadlineDate = moment(actionPlanData.deadline).format('YYYY-MM-DD');
        this.rootCause = actionPlanData.rootCause;
        this.action = actionPlanData.action;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  //load list from api
  async getUserList() {
    try {
      let response = await API.getUserList();

      if (response.data) {
        let users: User[] = response.data;
        this.userList = users;

        // this.filteredUserList = users;
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  validateIssueType() {
    if (validator.isNullOrEmpty(this.typeOfIssue)) {
      this.issueValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.issueValidationMsg = '';
      return true;
    }
  }

  validatePersonInCharge() {
    if (validator.isNullOrEmpty(this.personInCharge)) {
      this.personInChargeValiMsg = this.commonValidationMsg;
      return false;
    } else {
      this.personInChargeValiMsg = '';
      return true;
    }
  }

  validateAction() {
    if (validator.isNullOrEmpty(this.action)) {
      this.actionValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.actionValidationMsg = '';
      return true;
    }
  }

  validateDealine() {
    let deadlineDate = moment(this.deadlineDate).isValid();
    let futerDate = moment(this.deadlineDate).isAfter();

    if (validator.isNullOrEmpty(this.deadlineDate)) {
      this.deadlineValidationMsg = this.commonValidationMsg;
      return false;
    } else if (!deadlineDate || !futerDate) {
      this.deadlineValidationMsg = 'Please enter valid Deadline date, today or future date acceptable';
      return false;
    } else {
      this.deadlineValidationMsg = '';
      return true;
    }
  }

  validateAll() {
    return this.validateIssueType() && this.validatePersonInCharge() && this.validateDealine() && this.validateAction();
  }

  async onSaveClick() {
    if (this.validateAll()) {
      this.loadingBtnStatus = true;
      try {
        const params = {
          actionPlanId: null,
          inspectionId: this.inspectionId,
          actionPlan: {
            typeOfIssue: this.typeOfIssue,
            personInCharge: this.personInCharge,
            deadline: this.deadlineDate,
            rootCause: this.rootCause,
            action: this.action,
          },
        };
        const response = await API.saveActionPlanData(params);
        if (response.data) {
          this.showSuccessToast({msg: 'Saved successfully'});

          // const data = response.data;
          this.$router.push('/inspection-list');
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        console.error(error);

        this.showErrorToast({msg: 'Network Error'});
      } finally {
        this.loadingBtnStatus = false;
      }
    }
  }

  onCancelClick() {
    this.$router.go(-1);
  }
}
